import { db, collection, query, where, getDocs, doc, getDoc, functions } from "../../firebaseClient";
import { formatDate, parseDate } from "../utils/dateUtils";
import { ApprovalRequest, ContractDoc } from "../types/legalOps";
import { isApprovalPendingForUser, SummaryUserKey } from "../utils/approvalHelpers";
import { ApprovalFlow } from "../types/approval";
import { getRandomWarmTip } from "../utils/getRandomWarmTip";
import { getDashboardTodosOnce } from "./todosService";

// --- Types ---

export interface SummaryCounts {
  contracts: number;
  seals: number;
  // Broken down "Others"
  compliance: number; // GOV_PROJECT, LAW_INFO
  governance: number; // CORE_DOC, GOV_OBLIGATION
  cases: number;      // DISPUTE, LITIGATION
  // Added templates property to SummaryCounts
  templates: number;
  others: number;     // Fallback
  total: number;
}

export interface PendingItem {
  id: string;          
  title: string;
  module: string;
  // Traceability Fields
  docNo?: string;
  currentStage?: string;
  flowStatus?: string;
  stageStatus?: string;
  assignee?: string;
  reason?: string;
  submittedAt?: string;
}

export interface PendingGrouped {
  contracts: PendingItem[];
  seals: PendingItem[];
  cases: PendingItem[];
  compliance: PendingItem[]; // New
  governance: PendingItem[]; // New
  // Added templates property to PendingGrouped
  templates: PendingItem[];
  others: PendingItem[];
}

export interface DueItem {
  title: string;
  date: string;
  type: string;
}

export interface DueSoonGroup {
  today: DueItem[];
  within30: DueItem[];
  within60: DueItem[];
}

export interface UserRealtimeSummary {
  userKey: "kevin" | "lisa" | "irene";
  displayName: string;
  counts: SummaryCounts;
  dateLabel: string;
  agenda: string[]; 
  dueSoon: DueSoonGroup;
  pendingList: PendingGrouped; 
  encouragement: string;
}

export interface DailySummaryResult {
  generatedAt: string;
  users: UserRealtimeSummary[];
  emailStatus?: { status: string; info?: string; time?: any };
  byUser?: Record<string, UserRealtimeSummary>;
  meta?: {
      totalActive: number;
      unknownCount: number;
      source: "TODOS";
  };
}

const USERS: { key: SummaryUserKey; displayName: string; role: string }[] = [
  { key: "kevin", displayName: "Kevin (法務部)", role: "legal" },
  { key: "lisa", displayName: "Lisa (主管)", role: "manager" },
  { key: "irene", displayName: "Irene (主管)", role: "manager" },
];

const addDaysDate = (date: Date, days: number): Date => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    result.setHours(0, 0, 0, 0);
    return result;
};

/**
 * Triggers the daily summary email by calling Cloud Function directly.
 */
export async function triggerDailySummaryEmail(to = 'kevinckc1983@gmail.com'): Promise<void> {
    const fn = functions.httpsCallable('sendDailySummaryNow');
    try {
        const res = await fn({ to });
        const data = res.data as any;
        if (!data?.ok) {
            throw new Error("Server returned unsuccessful status");
        }
    } catch (e: any) {
        console.error("Failed to send summary email", e);
        throw new Error(e.message || "Failed to trigger email");
    }
}

/**
 * Explicit named export to resolve ESM import errors in Shell.tsx.
 * Acts as a compatibility alias for getDashboardTodosOnce.
 */
export async function getTodaySummary(): Promise<DailySummaryResult> {
  return getDashboardTodosOnce();
}
